<div class="container col-10">

    <div>
        <div class="modal-header">
            <h5 class="modal-title text-start">Deseja realmente desativar a nota abaixo ?</h5>
        </div>
    </div>
    <div>
    
        <div class="row">
            <div class="bn-form-group  col-md-12">
                <label for="agenteNotaDesativacao"><b>Agente</b></label>
                <input readonly type="text" class="form-control" id="agenteNotaDesativacao" name="agenteNotaDesativacao"
                    value="{{ nomeAgenteFinanceiro(nota.idAgenteFinanceiro) }}" />
            </div>
        </div>
        <div class="row">
            <div class="bn-form-group  col-md-6">
                <label for="classeOperacaoNotaDesativacao"><b>Tipo Operação/Sistema</b></label>
                <select name="classeOperacaoNotaDesativacao" id="classeOperacaoNotaDesativacao" class="form-select"
                    [value]=" nota.sistemaRepasse" disabled>
                    <option *ngFor="let classeOperacao of classesOperacao" [value]="classeOperacao.codigo">{{
                        classeOperacao.nome }}
                    </option>
                </select>
    
            </div>
            <div class="bn-form-group  col-md-6">
                <label for="dataPublicacao"><b>Publicado em</b></label>
                <input readonly type="text" class="form-control" id="dataPublicacao" name="dataPublicacao"
                    value="{{  nota.dataEnvio | date: 'dd/MM/yyyy HH:mm' }}" />
    
            </div>
            <div class="bn-form-group  col-md-12">
                <label for="nomeUsuarioEnvio"><b>Enviado por </b></label>
                <input readonly type="text" class="form-control" id="nomeUsuarioEnvio" name="nomeUsuarioEnvio"
                    class="form-control" value="{{  nota.nomeUsuarioEnvio }}" />
            </div>
    
            <div class="bn-form-group  col-md-12">
                <label for="notaDesativacaoMensagem"><b>Mensagem</b></label>
                <textarea name="notaDesativacaoMensagem" id="notaDesativacaoMensagem" rows="5" class="form-control" disabled
                    value="{{  nota.mensagem }}"></textarea>
            </div>
    
        </div>

        <div class="d-flex justify-content-center">
            <button class="btn btn-danger col-md-3" (click)="confirmaDesativacao()">Sim</button>
            <button class="btn btn-light col-md-3" (click)="fechar()">Não</button>
        </div>

    </div>
</div>
